// const facetAccordions = () => {
//     $(".checkbox-facet > div").removeClass("active");
//
//     $(".checkbox-facet > ul").slideUp("fast");
//
//     $(".facets > div:first-child > div").addClass("active");
//     $(".facets > div:first-child > div").next().slideToggle("fast");
//
//     $(".facets")
//         .find(".checkbox-facet > div")
//         .click(function () {
//             if ($(this).hasClass("active")) {
//                 $(this).removeClass("active");
//             } else {
//                 $(this).addClass("active");
//             }
//
//             $(this)
//                 .next()
//                 .slideToggle("fast");
//
//             $(".checkbox-facet > div")
//                 .not($(this))
//                 .removeClass("active");
//
//             $(".checkbox-facet > ul")
//                 .not($(this).next())
//                 .slideUp("fast");
//         });
// };
//
//
// $(document).ready(() => {
//     if ($(".fb_results").length > 0) {
//         facetAccordions();
//     }
//     ;
// });
